import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

export const errorActions = {
  handleError: createAction(
    '[Error] Handle error',
    props<{ response: HttpErrorResponse }>()
  )
};
